import { render } from "./MovimientoDeStock.vue?vue&type=template&id=4d8e54e4&scoped=true"
import script from "./MovimientoDeStock.vue?vue&type=script&lang=js"
export * from "./MovimientoDeStock.vue?vue&type=script&lang=js"

import "./MovimientoDeStock.vue?vue&type=style&index=0&id=4d8e54e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8e54e4"]])

export default __exports__